export default {

    sqm: [
        0,
        10,
        30,
        50,
        80,
        100,
        150
    ],

    price: [
        0,
        1000,
        3000,
        5000,
        8000,
        10000,
        15000
    ],

    builtAt: [
        1950,
        1960,
        1970,
        1980,
        1990,
        2000,
        2010,
        2020
    ],

    dealtAt: [
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
    ],

    sort: [
        'building.type',
        'dealtAt',
        'building.name',
        'building.address',
        'dealPrice',
        'sqm',
        'landSqm',
        'floorPlan',
        'floor',
        'roomNumber',
        'building.builtAt',

        'minBuiltAt',
        'minDealPrice',
        'minDealtAt',
        'minSqm',
        'minFloorPlan',
        'minFloor',
        'maxBuiltAt',
        'maxDealPrice',
        'maxDealtAt',
        'maxSqm',
        'maxFloorPlan',
        'maxFloor'
    ]

}
